<template>
	<section class="subscribe">
    <h2 v-if="isSubscribed" class="text-center">Va multumim.</h2>

    <form v-else=""
          @submit.prevent="make_subscribe">
      <h4 class="text-center">{{ subscribe.title }}</h4>

      <label for="newsletter-email">{{ subscribe.email }}:</label>
      <input id="newsletter-email"
             name="email"
             v-model="subscriber"
             v-validate="'required|email'"
             type="email"
             :placeholder="subscribe.email">
      <span class="alert">{{ errors.first('email') }}</span>

      <button type="submit"
              class="contact-btn flex">SUBSCRIBE</button>
    </form>
	</section>
</template>

<script>
	export default {
		name: 'subscribe',
		data () {
			return {
        subscriber: '',
        isSubscribed: false,
        subscribe: {
          title: 'Newsletter',
          email: 'email'
        }
			}
		},
		methods: {
      make_subscribe () {
        this.$validator.validate().then(result => {
          const clbk = () => {
            this.isSubscribed = true
            this.subscriber = ''
          }
          result && this.$store.dispatch('save_subscriber', {email: this.subscriber, clbk})
        })
      }
		}
	}
</script>

<style lang="less">
	.subscribe {
	}
</style>